import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './styles/global.css';

createRoot(document.getElementById('root')!).render(<React.StrictMode><App /></React.StrictMode>);

// PWA: register the generated service worker (no-op in dev / when the plugin is disabled).
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => { navigator.serviceWorker.register('/sw.js').catch(() => undefined); });
}

// Dev-only hook for the browser smoke test (tools/e2e/smoke.mjs): inspect engine state without touching the UI.
const debugFlag = (() => { try { return new URLSearchParams(location.search).has('tonist-debug') || localStorage.getItem('tonist.debug') === '1' || JSON.parse(localStorage.getItem('tonist.settings') ?? '{}').debugAudio === true; } catch { return false; } })();
if (import.meta.env.DEV || debugFlag) {
  Promise.all([import('./engine'), import('./store/engineStore'), import('@tonist/presets'), import('./store/settingsStore'), import('./mandala/geometry'), import('@tonist/shared')])
    .then(([eng, store, presets, settings, geometry, shared]) => {
      (window as unknown as { __tonist: unknown }).__tonist = {
        engine: eng.getEngine(), engineStore: store.engineStore, presets: presets.PRESETS, settings: settings.useSettings,
        // enough music/geometry to let a test runner ask "what pitch is at this pixel"
        music: { layoutFor: geometry.layoutFor, hitTest: geometry.hitTest, zoneCentre: geometry.zoneCentre, pitchSpecHz: shared.pitchSpecHz, makeTuning: shared.makeTuning, saHz: shared.saHz, scaleById: shared.scaleById },
      };
    });
}
